'use client';

import { Content } from '@prismicio/client';
import { Simplify } from '../../../../../prismicio-types';
import { Subtitle, Title } from '../../components';
import styles from './personalLoansHero.module.scss';
import { useVisible } from '@/hooks';
import { Button, Container } from '@/components';
import { PersonalLoansHeroCards } from './PersonalLoansHeroCards/PersonalLoansHeroCards';

interface PersonalLoansHeroProps {
  data: Simplify<Content.HeroSlicePersonalLoansPrimary>;
}

export const PersonalLoansHero = ({ data }: PersonalLoansHeroProps) => {
  const [isVisible, id] = useVisible();

  return (
    <Container>
      <div className={styles.hero} id={id}>
        <div className={styles.content_wrapper}>
          <Title
            text={data.title}
            styles={styles.title}
            isVisible={isVisible}
          />
          <Subtitle
            subtitle={data.subtitle}
            styles={styles.subtitle}
            isVisible={isVisible}
          />
          <div
            className={`${styles.button_wrapper} ${isVisible ? styles.isVisible : ''}`}
          >
            <Button link={data.button_link} text={data.button_text} isArrow />
          </div>
        </div>
        <PersonalLoansHeroCards data={data} isVisible={isVisible} />
      </div>
    </Container>
  );
};
